import React from 'react';
import { AlertTriangle, SearchX } from 'lucide-react';
import { Button, EmptyState } from '@mts/ui';

function DirectoryResultsState({
  type = 'empty',
  message = '',
  onClearFilters,
  onRetry,
}) {
  if (type === 'error') {
    return (
      <EmptyState
        icon={<AlertTriangle />}
        title="Error Loading Businesses"
        description={message || 'Unable to load directory results right now.'}
        variant="error"
        primaryAction={<Button onClick={onRetry}>Retry</Button>}
      />
    );
  }

  return (
    <EmptyState
      icon={<SearchX />}
      title="No businesses found"
      description="Try adjusting your search or filter criteria"
      variant="search"
      primaryAction={
        <Button variant="outline" onClick={onClearFilters}>
          Clear Filters
        </Button>
      }
    />
  );
}

export default DirectoryResultsState;
